type ResultType = OfferP2P | undefined;
type ApiResponseType = ApiSchema['OfferCollectionResponse'];
type ParamsType = ApiSchema['OfferCollectionRequest'];

/**
 * Loads the final offer for a P2P product for specific trips and
 * real list of passengers
 */
export default async function apiLoadFinalOfferP2P(
    tripUp: Trip | undefined,
    tripDown: Trip | undefined,
    withEPR: ProductConfigP2P['hasEPR'],
    passengers: Passenger[],
    promotion?: Promotion,
    listingId?: string,

): Promise<ApiResult<ResultType>> {
    try {
        const requestedOfferParts: ApiSchema['OfferPartType'][] = [];
        if (withEPR === 'only') {
            requestedOfferParts.push('RESERVATION');
        }
        else if (withEPR === true) {
            requestedOfferParts.push('ADMISSION');
            requestedOfferParts.push('RESERVATION');
        }
        else {
            requestedOfferParts.push('ADMISSION');
        }

        return await callApiPost<ResultType, ApiResponseType, ParamsType>(
            '/offers',

            // Request body
            {
                tripIds: [
                    ...(tripUp ? [tripUp.id] : []),
                    ...(tripDown ? [tripDown.id] : []),
                ],
                offerSearchCriteria: {
                    requestedOfferParts,
                },
                anonymousPassengerSpecifications: getFinalPassengerSpecifications(passengers),
                // only use general promo code here, otherwise send via passengerSpec
                ...(promotion && promotion.promotionType === 'GENERAL' && {
                    promotionCodes: [promotion],
                }),
                ...(listingId && { listingId }),

            },

            // Transform result
            (response: ApiResponseType): ResultType => response.offers?.[0]
                ? transformOfferP2P(response.offers?.[0])
                : undefined,
        );
    }
    catch (error) {
        throw new Error('Failed to load final P2P offer', { cause: error });
    }
}

function getFinalPassengerSpecifications(passengers: Passenger[]): ApiSchema['AnonymousPassengerSpecification'][] {
    return passengers.map(p => ({
        externalRef: p.ref,
        type: 'PERSON',
        dateOfBirth: formatDateISO(p.dateOfBirth),
        cards: p.reductionCards,
        ...(p.promotionCode && { promotionCode: { code: p.promotionCode } }),
    }));
}
